import { useCallback } from "react";
import { To, useNavigate } from "react-router-dom";

type SaveBarElement = HTMLElement & { hide?: () => Promise<void> };

// App Bridge forwards every in-app pushState to the admin, and the admin refuses the navigation
// while a save bar is showing. Hide any save bar first, then navigate on the next task, after
// App Bridge has told the admin the bar is gone.
export function useSaveBarSafeNavigate() {
  const navigate = useNavigate();

  return useCallback((to: To) => {
    document.querySelectorAll<SaveBarElement>("ui-save-bar").forEach((saveBar) => saveBar.hide?.());
    setTimeout(() => navigate(to), 0);
  }, [navigate]);
}
